import React from 'react'
import Merchants from './Merchants'
import Retailers from './Retailers'

const Available = () => {
    return (
        <div>
            {/* <Merchants></Merchants>   */}
            <Retailers/>
        </div>
    )
}

export default Available
